import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {mcpRegistryAppBuilder} from './config/app-builder'

import {mcpRegistryRoute} from './routes/mcp-registry-route'
import {mcpDetailsRoute} from './routes/mcp-details-route'
import {McpRegistry} from './routes/McpRegistry/McpRegistry'
import {McpDetails} from './routes/McpDetails/McpDetails'

export const mcpRegistryApp = mcpRegistryAppBuilder.createDataRouterAppFromRoutes([
  mcpRegistryRoute.toRoute({Component: McpRegistry}),
  mcpDetailsRoute.toRoute({Component: McpDetails}),
])
registerDataRouterApp(mcpRegistryApp)
